export default "__VITE_ASSET__5454648a__"